<script>
	import Agent from '../States/Agent';
	import Conference from '../States/Conference';
	import Contact from '../States/Contact';
	import Router from '../States/Router';
	import Trigger from '../States/Trigger';
	import Twilio from '../States/Twilio';
	import Helper from '../Models/Helper';
	import Sidebar from './Sidebar.svelte';
	import AgentInfo from './Agent/Info.svelte';
	import ContactInfo from './Contact/Info.svelte';
	import ContactTimeline from './Contact/Timeline.svelte';
	import AgentTimeline from './Agent/Timeline.svelte';
	import ConferenceParticipants from './Conference/Participants.svelte';

	const data = $Router.data;
	let show = data.show;
	let conference = $Conference.call;
	let fetchedContact = false;
	setTimeout(() => window.$('button[title]').tooltip({trigger: 'hover'}), 500);
	Conference.subscribe(state => {
		conference = show ? state.current : state.call;

		if(conference.id && !show) {
			$Router.data.show = true;
			$Router.data.id = conference.id;
			if(conference?.contact?.id)
				$Router.data.contactId = conference?.contact?.id;
		}
	});

	Trigger.subscribe(state => {
		if(Trigger.is('participants')) {
			setTimeout(() => window.$('[data-bs-toggle]').tooltip({trigger: 'hover'}), 500);
			let localForwarding = 0;
			for(const participant of conference.participants)
				if(participant.forwarding)
					localForwarding = 1;

			conference.forwarding = localForwarding;
		}

	});

	init();

	async function setCall(type) {
		if(type == 'contact')
			await Contact.call();
		else if(type == 'agent')
			await Twilio.callNumber(conference?.agent?.details?.mail);

		$Router.data.call = false;
		Conference.setActive(true);
		Conference.clearEvents();
	}

	async function pickup() {
		$Router.data.pickup = false;
		await join(data.conferenceName);
	}

	async function answer() {
		$Router.data.answer = false;
		if($Twilio.call) {
			Conference.setActive(true);
			$Twilio.call.accept();
			Conference.clearEvents();
		} else
			join(data.conferenceName);
	}

	async function join(conferenceName) {
		Conference.setActive(true);
		await Contact.join(conferenceName);
		Conference.clearEvents();
	}

	async function disconnect() {
		await Conference.disconnect();
	}

	async function getInfo(id, contactId) {
		if(!fetchedContact) {
			const response = await Contact.get(contactId);
			if(show && response.success) {
				Conference.setContact(response.contact, response.timeline, show);
			}
		}
		Conference.get(id)
	}

	function forward(toAgentId) {
		Conference.forward(conference.id, toAgentId);
	}

	function call() {
		Router.component('conference', {call: true, contact: !!data.contactId, agent: data.agent, agentId: data.agentId, contactId: data.contactId})
	}

	function setJoin() {
		join(conference.name);
		Conference.setContact(conference.contact.details, conference.contact.timeline, false);
		show = false;
	}

	async function init() {
		if(data.contact) {
			if(data.contactId) {
				if(!conference.active || !conference.contact && !show) {
					const response = await Contact.get(data.contactId);
					if(response.success) {
						fetchedContact = true;
						Conference.setContact(response.contact, response.timeline, show);
					}
				}
			}
			if(data.call) setCall('contact');
			if(data.pickup) pickup();
			if(data.answer) answer();
		}

		if(data.agentId) {
			const response = await Agent.get(data.agentId);
			if(response.success)
				Conference.setAgent(response.agent, response.agent.timeline, show);

			if(data.call) setCall('agent');
			if(data.pickup) {
				$Router.data.pickup = false;
				answer();
			}

			Helper.cardLoading('.card-disabled', false);
		}

		if(data.id && data.contactId)
			getInfo(data.id, data.contactId);
	}
</script>

<style>
	#agents .round-name {
		position: relative;
		float: left;
		margin-right: 1.1em;
	}

	#agents .inbox-item {
		display: grid;
		align-items: center;
		grid-template-columns: 16% auto;
	}

	.forward-button {
		font-size: 1.6em;
	}

</style>

<div class="container-fluid">
	<div class="wrapper">
		<Sidebar/>
		<div class="content-page">
			<div class="content">
				<div class="row">
					<div class="col-12">
						<div class="page-title-box">
							<h4 class="page-title">Conference</h4>
						</div>
					</div>
				</div>

				<div class="row">
					{#if data.contactId || (conference.active && !data.agentId)}
						<div id="contact-info" class="col-xxl-3 col-xl-6 order-xl-1 order-xxl-2">
							<ContactInfo on:call="{call}" on:join={setJoin} on:hangup={disconnect} bind:conference={conference} bind:contact={conference.contact.details}/>
							<ContactTimeline bind:timeline={conference.contact.timeline}/>
						</div>
					{:else if data.agentId}
						<div id="agent-info" class="col-xxl-3 col-xl-6 order-xl-1 order-xxl-2">
							<AgentInfo on:call="{call}" on:join={setJoin} on:hangup={disconnect} bind:conference={conference} bind:agent={conference.agent.details}/>
							<!-- <AgentTimeline bind:timeline={conference.agent.timeline}/> -->
						</div>
					{/if}

					<div id="agents" class="col-xxl-3 col-xl-6 order-xl-1 order-xxl-2">
						<ConferenceParticipants bind:conference={conference}/>
						<div class="card">
							<div class="card-body">
								<h4 class="header-title mb-3">Forward</h4>
								<div class="inbox-widget">
									{#each $Agent.list as agent}
										<div class="inbox-item">
											<div class="round-name">{agent.initials}</div>
											<p class="inbox-item-author">{agent.name}</p>
											{#if conference.active && !conference.forwarding}
												<div class="inbox-item-date">
													<button class="btn btn-sm btn-link forward-button" data-bs-toggle="tooltip" data-bs-placement="top" title="Forward to agent" on:click={() => forward(agent.id)}><i class="uil-forwaded-call"></i> </button>
												</div>
											{/if}
										</div>
									{/each}

									<!-- <div class="inbox-item">
										<div class="round-name">PR</div>
										<p class="inbox-item-author">Patrick van Rijn <span class="badge bg-danger">Live</span></p>
										<div class="inbox-item-date">
											<button class="btn btn-sm btn-link text-danger forward-button" data-bs-toggle="tooltip" data-bs-placement="top" title="Forward to agent" disabled><i class="uil-forwaded-call"></i> </button>
										</div>
									</div> -->
								</div>
							</div>
						</div>
					</div>
					<!-- <div id="contact-timeline" class="col-xxl-3 col-xl-6 order-xl-1 order-xxl-2">

					</div> -->
					<div id="conference-timeline" class="col-xxl-3 col-xl-6 order-xl-1 order-xxl-2">
						<div class="card">
							<div class="card-body">
								<h4 class="header-title mb-3">Conference Timeline</h4>
								<div data-simplebar="" style="max-height:500px">
									<div class="timeline-alt pb-0">
										{#each conference.events as event}
											<div class="timeline-item">
												<i class="uil uil-phone-alt bg-dark-lighten text-dark timeline-icon"></i>
												<div class="timeline-item-info">
													<div class="text-dark fw-bold mb-1 d-block">{event.title}</div>
													<small>{event.text}</small>
													<p class="mb-0 pb-2">
														<small class="text-muted">{event.dateTime}</small>
													</p>
												</div>
											</div>
										{/each}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>